import React, { useState, useEffect } from "react";
import { Dropdown, DropdownItemProps, Form, Grid, Radio } from "semantic-ui-react";
import axios from "axios";
import LocalStorage from "../../../../lib/LocalStorage";
import UserRepository from "../../../../common/repository/UserRepository";
import constants from "../../../../common/constants";
import Result from "../../../../common/repository/Result";
import { toast } from "../../../common/Toast";
import DateTimePicker from "../../../app/DateTimePicker";
import config from "../../../../common/repository/config";

function MrdDocumentDownloadForm({ onSuccess }: Props) {
  const [userOptions, setUserOptions] = useState<DropdownItemProps[]>([]);
  const [investigatorId, setInvestigatorId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isPaymentPending, setIsPaymentPending] = useState<boolean | null>(null);  
  const userRepo = new UserRepository();

const paymentOptions = [
  { key: "pending", value: true, text: "Pending" },
  { key: "approved", value: false, text: "Approved" },
];
  const loadEssentialData = async () => {
    let userRole = constants.roleTitle.investigator;
    const userData = await userRepo.getUsers({
      role: userRole,
      is_active: true,
    });
    if (userData instanceof Result.Success) {
      setUserOptions(
        userData.data.items.map((it) => ({
          text: it.getName(),
          value: it.getId(),
          key: it.getId(),
        }))
      );
    } else {
      const message = userData.message || "Could not load Users";
      toast.error(message);
    }
  };

  useEffect(() => {
    if (userOptions.length == 0) {
      loadEssentialData();
    }
  }, []);
  async function downloadTemplate() {
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

    const payload: any = {
      from: fromDate.length > 0 ? fromDate : undefined,
      to: toDate.length > 0 ? toDate : undefined,
    };

    if (investigatorId.length > 0) {
      payload.investigatorId = investigatorId;
    }

    payload.isPaymentPending = isPaymentPending ? true : false;

    try {
      const response = await axios({
        url: config.apiBaseURL + `/case/downloadMrdTemplate`,
        method: "POST",
        data: payload,
        responseType: "blob",
        headers: { "x-access-token": token },
      });


      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        const data = JSON.parse(text);
        toast.error(data.message || "No Mrd Data Found");
        return;
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "mrdTemplatedownload.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Download started successfully!");
      if (onSuccess) onSuccess();
    } catch (error) {
      const err = error as any;
      if (err.response?.data) {
        try {
          const reader = new FileReader();
          reader.onload = () => {
            const msg = JSON.parse(reader.result as string).message;
            toast.error(msg || "No Mrd Data Found");
          };
          reader.readAsText(err.response.data);
        } catch {
          toast.error("No Mrd Data Foundss");
        }
      } else {
        toast.error("No Mrd Data Foundss");
      }
    }
  }

  return (
    <Form>
      <Form.Input label="From Date">
        <DateTimePicker
          placeholder="Select From Date"
          type="date"
          value={fromDate}
          onChange={(val) => setFromDate(val)}
        />
      </Form.Input>

      <Form.Input label="To Date" disabled={fromDate.length === 0}>
        <DateTimePicker
          placeholder="Select To Date"
          type="date"
          value={toDate}
          onChange={(val) => setToDate(val)}
        />
      </Form.Input>

      <Form.Dropdown
        label="Choose Investigator"
        search
        selection
        placeholder="Select Investigator"
        options={userOptions}
        value={investigatorId}
        onChange={(_, { value }) => setInvestigatorId(value as string)}
      />

      <Form.Field>
        <label>Download Type</label>
        {/* <label>Payment Pending</label */}
     <Dropdown
  placeholder="Select Status"
  selection
  options={paymentOptions}
  value={isPaymentPending === null ? undefined : isPaymentPending}
  onChange={(_, data) => setIsPaymentPending(data.value as boolean)}
/>

      </Form.Field>

      <Form.Button positive onClick={downloadTemplate}>
        Download
      </Form.Button>
    </Form>
  );
}

interface Props {
  onSuccess?(): void;
}

export default MrdDocumentDownloadForm;
